export default __webpack_public_path__ + "static/media/capstone-server.6eb67f47.svg";